module.exports = __webpack_public_path__ + "static/wdjs-2e1f56517bf13e4ca7193ca72aec835e.jpg";